export default [
    {
        path: 'login',
        name: 'login',
        component: () => import('@/views/pages/auth/login.vue')
    },
    {
        path: 'logout',
        name: 'logout',
        component: () => import('@/views/pages/auth/logout.vue')
    },
    {
        path: 'register',
        name: 'register',
        component: () => import('@/views/pages/auth/register.vue')
    },
    {
        path: 'lock-screen',
        name: 'lock-screen',
        component: () => import('@/views/pages/auth/lock-screen.vue')
    },
    {
        path: 'recover-password',
        name: 'recover-password',
        component: () => import('@/views/pages/auth/recover-password.vue')
    },
    {
        path: 'reset/:token',
        name: 'reset-password',
        component: () => import('@/views/pages/auth/reset-password.vue')
    },
    {
        path: 'confirm-mail',
        name: 'confirm-mail',
        component: () => import('@/views/pages/auth/confirm-mail.vue')
    },
    {
        path: 'two-step-verification',
        name: 'two-step-verification',
        component: () => import('@/views/pages/auth/two-step-verification.vue')
    },
    {
        path: 'email-verification',
        name: 'email-verification',
        component: () => import('@/views/pages/auth/email-verification.vue')
    },
]